<template>
	<div class="products-lits">
		<button 
			class="btn-search" 
			@click="searchBtn" 
			v-show="search">BUSCAR</button>
		<div class="products-list-menu" v-show="!search">
			<div class="products-list-input-search">
				<searching-input
					class="product-search"
					placeholder="Buscar..."
					v-model="params.search"
					@search="searchProduct"
				/>
				<button 
					class="btn-close"
					@click="searchBtn">
					<img 
						src="/static/img/icon-close.svg" 
						alt="cerra buscador">
				</button>
			</div>
			<div class="list-menu">
				<btn-edit
					v-if="editable"
					background="#001d32"
					icon="edit-white"
					@edit-section="openModal"
				/>
				<div v-for="(item, index) in categories" :key="index">
					<div
						:class="[
							'container-list-menu',
							currentId === item.id ? 'active-category' : null
						]"
						@click="filterProductsByCategory(item.id)">
						<span class="list-title-menu">{{item.title}}</span>
						<span
							class="list-icon-drop" 
							v-if="item.subCategories" 
							v-show="!item.deploy"
							@click="seeList(index)">+</span>
						<span class="list-icon-drop" 
							v-if="item.subCategories"
							v-show="item.deploy"
							@click="seeList(index)">-</span>
					</div>
					<ul class="list-products"
						v-if="item.subCategories"
						v-show="item.deploy">
						<li
							:class="[
								'container-list-menu',
								currentId === list.id ? 'active-category' : null
							]"
							v-for="(list, index) in item.subCategories.data"
							@click="filterProductsByCategory(list.id)"
							:key="index">{{list.title}}</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="flex wrapper-products-list-items" v-show="product">
			<div
				v-if="!products.length"
				class="no-products-container"
			>
				<h1 class="no-product-found">No se encontraron productos.</h1>
			</div>
			<router-link
				class="products-list-item"
				v-for="(item, index) in products"
				:key="index"
				:to="`/productos/detalle/${sluggedName(item.title)}`">
				<div class="flex item-image-wrapper">
					<img
						class="item-image"
						:src="item.imagePrevious"
						:alt="item.name" />
				</div>
				<h3 class="item-name">{{item.title}}</h3>
				<h4 class="item-subtitle">{{item.subtitle}}</h4>
				<button class="btn btn-black item-button">Ver Detalles</button>
			</router-link>
		</div>
		<div class="line"></div>
		<btn-edit
			v-if="editable"
			:top="0"
			background="#001d32"
			icon="edit-white"
			@edit-section="toNewProduct"
		/>
		<edit-modal
			v-show="showModal"
		>
			<category-form
				@close-modal="closeModal"
				@update-categories="updateCategories"
			/>
		</edit-modal>
	</div>
</template>

<script>
import orderBy from 'lodash/orderBy';
import searchingInput from '@/components/commons/searching-input';
import btnEdit from '@/components/commons/btn-edit';
import editModal from '@/components/commons/edit-modal';
import categoryForm from '@/components/commons/category-form';

function mounted() {
	window.addEventListener('resize', this.handleWindowWidth);
	if (window.innerWidth < 884) {
		this.search = true;
		this.product = true;
	}
	if (this.$route.query.id) {
		this.filterProductsByCategory(this.$route.query.id);
	} else {
		const { products } = this.$store.state;
		this.products = products;
		this.loadData();
	}
}

async function loadData() {
	const urlProducts = `${process.env.ARIS_URL}/app/${process.env.APP_CODE}/products`;
	const requests = [
		this.$http.get(urlProducts),
	];
	const [
		{ data: products },
	] = await Promise.all(requests);
	this.products = orderBy(products.data, 'title');
}

function seeList(index) {
	this.categories[index].deploy = !this.categories[index].deploy;
}

function searchBtn() {
	this.search = !this.search;
	this.product = !this.product;
}

function destroyed() {
	window.removeEventListener('resize', this.handleWindowWidth);
}

function handleWindowWidth() {
	if (window.innerWidth > 884) {
		this.product = true;
		this.search = false;
	} else {
		this.product = true;
		this.search = true;
	}
}

function toNewProduct() {
	this.goTo('products-admin');
}

function goToProductDetails(product) {
	this.goTo('page-detail', { params: { id: product } });
}

function openModal() {
	this.showModal = true;
}

function closeModal() {
	this.showModal = false;
}

function updateCategories(newCategories) {
	this.categories = newCategories.map((item) => {
		const newCat = { ...item };
		newCat.deploy = true;
		return newCat;
	});
	this.categories.unshift({ id: '', title: 'TODOS' });
}

async function filterProductsByCategory(id) {
	const urlProducts = `${process.env.ARIS_URL}/app/${process.env.APP_CODE}/products`;
	const { data: products } = await this.$http.get(`${urlProducts}?categoryId=${id}`);
	this.products = products.data;
	this.currentId = id;
	if (window.innerWidth < 884) {
		this.search = !this.search;
		this.product = !this.product;
	}
}

async function searchProduct(id) {
	const urlProducts = `${process.env.ARIS_URL}/app/${process.env.APP_CODE}/products`;
	const url = id ? `${urlProducts}?productId=${id}` : urlProducts;
	const { data: products } = await this.$http.get(url);
	this.products = products.data;
	this.currentId = id;
	if (window.innerWidth < 884) {
		this.search = !this.search;
		this.product = !this.product;
	}
}

function showModal(value) {
	this.onModal(value);
}

function data() {
	return {
		categories: [],
		currentId: 0,
		product: true,
		products: [],
		searchText: '',
		showModal: false,
		isLoading: false,
		results: [],
		noProducts: false,
		showSearchingMenu: false,
		showSeparater: false,
		search: false,
	};
}

export default {
	name: 'list',
	components: {
		btnEdit,
		categoryForm,
		editModal,
		searchingInput,
	},
	mounted,
	data,
	destroyed,
	methods: {
		closeModal,
		filterProductsByCategory,
		goToProductDetails,
		handleWindowWidth,
		loadData,
		openModal,
		searchBtn,
		seeList,
		toNewProduct,
		updateCategories,
		searchProduct,
	},
	watch: {
		showModal,
	},
};
</script>

<style lang="scss" scoped>

	.products-lits {
		position: relative;
		min-height: 500px;
	}
	
	.btn-search {
		@include font-size(16);
		@include font-maison-bold();
		background: map-get($colors, black-dark);
		border: none;
		color: map-get($colors, white);
		display: none;
		height: 60px;
		width: 100%;
	}

	.products-list-input-search {
		@include flex-center();
		background: map-get($colors, black-dark);
		justify-content: space-between;
		padding: 12px 23px 15px;
	}

	.products-list-menu {
		@include box-shadow(0, 2px, 6px, 0, rgba(158, 158, 158, 0.5));
		height: 100%;
		left: 0;
		overflow: scroll;
		position: absolute;
		width: 308px;
	}

	.wrapper-input {
		@include flex-center;
		@include border-radius(8px);
		background: map-get($colors, background-input);
		height: 34px;
		padding: 9px 13px;

		.search {
			@include font-muli-bold;
			@include font-size(12);
			background: none;
			border: none;
			color: map-get($colors, white);
			outline: none;
			width: 219px;

			&::placeholder {
				color: map-get($colors, white);
			}
		}
	}

	.close {
		@include font-maison-bold();
		@include font-size(21);
		color: map-get($colors, white);
		display: none;
		margin-left: 23px;
	}

	.container-list-menu {
		border-bottom: 1px solid map-get($colors, line-grey);
		cursor: pointer;
		padding: 10px 0;
		position: relative;

		.list-title-menu {
			@include font-maison-medium();
			@include font-size(11);
			cursor: pointer;
			margin-left: 5px;
		}
	}

	.list-products > li {
		@include font-maison-book-italic();
		@include font-size(10);
		color: map-get($colors, grey-list);	
		list-style: none;
		padding-left: 15px;
	}

	.list-icon-drop {
		@include font-maison-bold();
		@include font-size(20);
		cursor: pointer;
		position: absolute;
		right: 0px;
	}

	.list-menu {
		padding: 36px 35px;
	}

	.wrapper-products-list-items {
		flex-wrap: wrap;
		justify-content: space-around;
		margin-bottom: 20px;
		padding: 34px;
		transform: translateX(308px);
		width: calc(100vw - 308px);
}

.products-list-item {
	@include transition();
	@include box-shadow(0, 2px, 6px, 0, rgba(158, 158, 158, .5));
	background-color: map-get($colors, background-products);
	cursor: pointer;
	flex-direction: column;
	margin-bottom: 40px;
	max-width: 301px;
	padding-top: 20px;
	text-align: center;
	width: 30%;

	&:hover {
		@include box-shadow(0, 2px, 10px, 0, rgba(95, 127, 139, .4));
		@include transform(translateY(-20px) scale(1.05));
	}
}

.item-image-wrapper {
	align-items: center;
	background-color: map-get($colors, white);
	max-height: 250px;
	justify-content: center;
	overflow: hidden;
	margin: 0 20px 20px 20px;
	overflow: hidden;
}

.item-image {
	display: block;
	max-height: 250px;
	max-width: 100%;
	object-fit: cover;
	object-position: center;
}

.item-name {
	@include font-maison-demi();
	@include font-size(14);
	color: map-get($colors, name-product);
	margin-bottom: 5px;
}

.item-subtitle {
	@include font-size(14);
	color: map-get($colors, grey-input);
	margin-bottom: 10px;
	text-transform: uppercase;
}

.item-price {
	@include font-size(16);
	@include font-maison-bold();
	color: map-get($colors, product-price);
	margin-bottom: 10px;
}

.item-button {
	display: block;
	width: 100%;
}

.btn-more {
	@include display-flex;
	@include font-maison-medium;
	@include font-size(13);
	@include border-radius(3px);
	border: 1px solid map-get($colors, product-price);
	color: map-get($colors, product-price);
	height: 37px;
	margin-top: 31px;
	padding: 10px 14px;
	width: 147px;
}

.wrapper-btn-more {
	@include flex-center;
	width: 100%;
}

@media screen and (max-width: 1024px) {
	.wrapper-products-list-items {
		padding: 34px 0 0 0;

		.products-list-item {
			width: 45%;
		}
	}

	.btn-more {
		@include font-maison-bold;
		@include flex-center();
		@include border-radius(0);
		background: map-get($colors, black-dark);
		color: map-get($colors, white);
		height: 44px;
		text-transform: uppercase;
		width: 100%;
	}

	.btn-search {
		display: block;
	}
}

.line {
	background: map-get($colors, black-dark);
	border: none;
	bottom: 0;
	height: 11px;
	outline: none;
	position: absolute;
	width: 100%;
}

.btn-close {
	display: none;
}

.btn-search {
	background: map-get($colors, black-dark);
	color: map-get($colors, white);
	height: 77px;
}

@media screen and (max-width:884px) {
	.wrapper-products-list-items {
		transform: none;
		width: 100%;

		.products-list-item {
			width: 40%;
		}
	}

	.products-list-menu {
		position: relative;
		width: 100%;
	}

	.close {
		display: block;
	}

	.wrapper-input {
		.search {
			width: calc(100vw - 130px);
		}
	}

	.line {
		display: none;
	}

	.btn-close {
		@include flex-center();
	}
}

.product-search {
	width: 100%;
}

@media screen and (max-width: 546px){
	.wrapper-products-list-items {
		.products-list-item {
			width: 80%;
		}
	}
}

.no-products-container {
	align-items: center;
	display: flex;
	height: 200px;
	justify-content: center;
}

.no-product-found {
	color: map-get($colors, black-dark);
	font-size: map-get($sizes, large40);
	line-height: 42px;
	text-align: center;
}

.active-category {
	border-left: 5px solid map-get($colors, black-dark);
}
</style>



// WEBPACK FOOTER //
// src/components/product/list.vue